/**
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import { takeLatest } from "redux-saga/effects";
import * as ACTIONS from "../../action-types/account";
import { DELETE_ACCOUNT_REQUEST_ACTION } from "../../actions/account";
import * as WORKERS from "../workers/account";

/**
 * Account watch saga
 * watchers to intercept account actions
 */
export function* watchSaga() {
  yield takeLatest(ACTIONS.ADDRESS_DETAILS_GET_REQUESTED, WORKERS.fetchAddressDetails);
  yield takeLatest(ACTIONS.ACCOUNT_DETAILS_PUT_REQUESTED, WORKERS.updateAccountDetails);
  yield takeLatest(DELETE_ACCOUNT_REQUEST_ACTION, WORKERS.deleteAccount);
}
